import type { Url } from "@/v2/shared/types/Photo";

export enum VirtualStagingType {
  staging = "staging",
  enhancement = "enhancement",
  daytodusk = "daytodusk",
}

export type StagingOptions = {
  data: {
    staging: {
      style: string[];
      room_type: string[];
    };
    daytodusk: string[];
  };
};

export type ValueLabel = {
  value: string;
  label: string;
};

export type StagingGenerateRequestData = {
  tourId: string;
  originalName: string;
  photo: string;
  type: VirtualStagingType;
  params: {
    roomType: string;
    style: string;
    watermark: boolean;
    declutter: boolean;
    furniture: boolean;
  };
};

export type StagingGenerateResponseData = {
  data: {
    render_id: string;
    files: {
      id: number;
      originalName: string;
      urls: Url[];
    }[];
  };
};

export type StagingRegenerateRequestData = {
  tourId: string;
  originalName: string;
  renderId: string;
  type: VirtualStagingType;
  params: {
    roomType: string;
    style: string;
    watermark: boolean;
    furniture: boolean;
  };
};

export type StagingRegenerateResponseData = StagingGenerateResponseData;

export type StagingGenerateMultiViewRequestData = {
  tourId: string;
  originalName: string;
  photo: string;
  type: VirtualStagingType;
  params: {
    multiView: string;
    roomType: string;
    style: string;
    watermark: boolean;
    declutter: boolean;
    furniture: boolean;
  };
};

export type StagingGenerateMultiViewResponseData = {
  data: {
    render_id: string;
    files: {
      id: number;
      originalName: string;
      urls: Url[];
    }[];
  };
};

export type StagingRegenerateMultiViewRequestData = {
  tourId: string;
  originalName: string;
  renderId: string;
  type: VirtualStagingType;
  params: {
    multiView: string;
    roomType: string;
    style: string;
    watermark: boolean;
    furniture: boolean;
  };
};

export type StagingRegenerateMultiViewResponseData =
  StagingGenerateMultiViewResponseData;

export type StagingEnhancementRequestData = {
  tourId: string;
  originalName: string;
  photo: string;
  type: VirtualStagingType;
};

export type StagingEnhancementResponseData = StagingGenerateResponseData;

export type StagingDayToDuskRequestData = {
  tourId: string;
  originalName: string;
  photo: string;
  type: VirtualStagingType;
  params: {
    skyStyle: string;
  };
};

export type StagingDayToDuskResponseData = StagingGenerateResponseData;
